<template>
    <div class="comment card alert-dark">
        <div class="card-body py-2 px-3">
            <div class="d-flex px-1">
                <div class="flex-fill">
                    <span class="rounded" :title="global.moment(comment.created_at).format('dddd Do MMMM YYYY HH:mm')">
                        Commentaire posté {{ global.moment(comment.created_at).fromNow() }}
                    </span>
                    par
                    {{ comment.creator.name }}
                    <i v-if="comment.creator_type === 'contact'" class="fas fa-store" style="color:#139911"></i>
                    <i v-else-if="comment.creator_type === 'employee'" class="fas fa-tractor" style="color:#402916"></i>
                    <i>({{ comment.creator.type_label }})</i>
                    <span v-if="comment.creator_type === 'contact'" class="text-success ml-2">
                        <i class="fad fa-eye"></i> commentaire client (affiché sur le BL)
                    </span>
                    <span v-else-if="comment.public" class="text-success ml-2">
                        <i class="fad fa-eye"></i> commentaire visible par le client (affiché sur le BL)
                    </span>
                    <span v-else class="text-danger ml-2">
                        <i class="fad fa-eye-slash"></i> commentaire interne, non-visible par le client
                    </span>
                    <span v-if="comment.production_slip" class="ml-2">
                        <i class="fad fa-clipboard-list-check"></i> commentaire affiché sur les bons de fabrication
                    </span>
                </div>
                <div class="text-right">
                    <a class="text-danger"
                            href="javascript:void(0)"
                            v-if="comment.creator_type !== 'contact'"
                            @click="deleteComment()"
                            :disabled="deleting">
                        <i class="fas fa-times"></i> {{ deleting ? 'Suppression en cours' : 'Supprimer'}}
                    </a>
                </div>
            </div>
            <hr class="mt-1 mb-2">
            <div class="px-1 font-weight-bold">
                {{ comment.message }}
            </div>
        </div>

        <ErrorsZone :errors="errorsDeleting"></ErrorsZone>
    </div>
</template>

<script>
import ErrorsZone from "./ErrorsZone"

import {useDeleteRequest} from "./compositions/axios/deleteRequest"

export default {
    name: 'Comment',

    components: {
        ErrorsZone,
    },

    props: {
        comment: {
            type: Object,
            required: true,
        },
    },

    setup(props) {
        let { deleting, deleted, errorsDeleting, doDelete } = useDeleteRequest();
        return { deleting, deleted, errorsDeleting, doDelete };
    },

    methods: {
        async deleteComment() {
            if(confirm('Êtes vous sûr de vouloir supprimer ce commentaire ?')) {
                const response = await this.doDelete(`/espace-employes/commentaires/${this.comment.id}`);
            } else {
                return false;
            }
        },
    }
}
</script>
